import api from "utils/helper/api";
import {
  DETAILS_TENDER_UMUM,
  RESET_DETAILS_TENDER_UMUM,
  RESET_TABLES_TENDER_UMUM,
  TABLES_TENDER_UMUM,
} from "./tenderUmumTypes";

export const setTablesTenderUmum = (payload) => {
  return {
    type: TABLES_TENDER_UMUM,
    payload,
  };
};
export const resetTablesTenderUmum = () => {
  return {
    type: RESET_TABLES_TENDER_UMUM,
  };
};

export const setDetailsTenderUmum = (payload) => {
  return {
    type: DETAILS_TENDER_UMUM,
    payload,
  };
};

export const resetDetailsTenderUmum = () => {
  return {
    type: RESET_DETAILS_TENDER_UMUM,
  };
};

export const getTenderUmum = (payload) => async (dispatch, getState) => {
  try {
    await dispatch(
      setTablesTenderUmum({
        key: "isLoading",
        value: true,
      })
    );
    const params = {
      pageNumber: payload?.currentPage,
      pageSize: payload?.pageSize,
      tahun: payload?.tahun,
    };

    if (payload?.keyword && String(payload.keyword).trim() !== "") {
      params.keyword = String(payload.keyword).trim();
    }

    const { data } = await api.apiGet("/TenderUmum", params);

    if (data?.Data) {
      await dispatch(
        setTablesTenderUmum({
          key: "data",
          value: data?.Data?.map((val) => {
            return {
              id: val?.paket_id,
              no: val?.nomer,
              tanggal: val?.tanggal,
              lokasi: val?.lokasi,
              nama: val?.nama,
              bidang: val?.bidang,
              daftar: val?.daftar,
              tracking_number: val?.tracking_number,
              is_perdir: val?.is_perdir
            };
          }),
        })
      );
      await dispatch(
        setTablesTenderUmum({
          key: "currenPage",
          value: data?.PageNumber,
        })
      );
      await dispatch(
        setTablesTenderUmum({
          key: "pageSize",
          value: data?.PageSize,
        })
      );
      await dispatch(
        setTablesTenderUmum({
          key: "totalData",
          value: data?.TotalItems,
        })
      );
    } else {
      await dispatch(
        setTablesTenderUmum({
          key: "data",
          value: null,
        })
      );
    }
    await dispatch(
      setTablesTenderUmum({
        key: "isLoading",
        value: false,
      })
    );
  } catch (error) {
    return Promise.reject(error);
  }
};

export const getTenderUmumDetail = (paketId) => async (dispatch, getState) => {
  try {
    await dispatch(
      setDetailsTenderUmum({
        key: "isLoading",
        value: true,
      })
    );

    const { data } = await api.apiGet(`/TenderUmum/Detail/${paketId}`); 
    if (data?.Data) {    
      await dispatch(
        setDetailsTenderUmum({
          key: "data",
          value: data?.Data,
        })
      );

      // Set loading to false after successful data fetch
      await dispatch(
        setDetailsTenderUmum({
          key: "isLoading",
          value: false,
        })
      );

      return data?.Data;
    }

    // Set loading to false if no data
    await dispatch(
      setDetailsTenderUmum({
        key: "isLoading",
        value: false,
      })
    );
  } catch (error) {
    console.error('getTenderUmumDetail - Error:', error);
    // Set loading to false on error
    await dispatch(
      setDetailsTenderUmum({
        key: "isLoading",
        value: false,
      })
    );
    return Promise.reject(error);
  }
};
